import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupComponent } from './popup.component';
import { QuillModule } from 'ngx-quill';
import { RouterModule } from '@angular/router'; // <-- import this
import { FormsModule } from '@angular/forms';
import { PopupRoutingModule } from './popup-routing.module';
import { ThemeModule } from '../@theme/theme.module';
import { ActionPointMailComponent } from './action-point-mail/action-point-mail.component';
import { NrkWindowComponent } from '../pages/erp/shared/nrk-window/nrk-window.component';
import { PagesModule } from '../pages/pages.module';
import { NbPopoverModule, NbPopoverDirective } from '@nebular/theme';
import { DocFormCheckboxComponent } from '../pages/erp/shared/doc-form-checkbox/doc-form-checkbox.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ThemeModule,
    PopupRoutingModule,
    FormsModule,
    QuillModule.forRoot(),
    PagesModule,
    NbPopoverModule,
  ],
  declarations: [
    PopupComponent,
    ActionPointMailComponent,
  ]
})
export class PopupModule { }
